export enum DialogContentType {
    PaymentSuccess = 'PaymentSuccess',
    RequestSentSuccessfully = 'RequestSentSuccessfully',
    Failed = 'Failed'
}

export enum DialogType {
    confirm = 'confirm',
    information = 'info'
}
